import React, { useEffect, useContext } from 'react';
import { makeStyles, Container } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useForm } from 'react-hook-form';
import UTextField from 'components/UTextField';
import UButton from 'components/UButton';
import { useSnackbar } from 'notistack';
import schema from './schema';

import { ValidacaoContext } from '../Context';

const useStyles = makeStyles((theme) => ({
  formContainer: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
}));

function Form() {
  const classes = useStyles();

  const {
    handleSubmit, register, errors, reset, setValue,
  } = useForm({
    validationSchema: schema,
  });

  const { enqueueSnackbar } = useSnackbar();

  const {
    fetch,
    loading,
    data,
    error,
    codigoConsulta,
  } = useContext(ValidacaoContext);

  useEffect(() => {
    if (error) {
      const { message } = error;
      enqueueSnackbar(message, { variant: 'error' });
    }
  }, [reset, error, enqueueSnackbar]);

  useEffect(() => {
    if (codigoConsulta) {
      setValue('codigo', codigoConsulta);
    }
  }, [codigoConsulta, setValue]);

  const onSubmit = (form) => fetch(form.codigo);

  return !data && (
    <Container maxWidth="xs">
      <form className={classes.formContainer} onSubmit={handleSubmit(onSubmit)} noValidate>
        <UTextField
          margin="normal"
          required
          fullWidth
          label="Código do Documento"
          name="codigo"
          autoComplete="codigo"
          autoFocus
          inputRef={register}
          error={Boolean(errors.codigo)}
          helperText={errors.codigo && errors.codigo.message}
          disabled={loading}
        />
        <UButton
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          size="large"
          disabled={loading}
          endIcon={<SearchIcon />}
          gutterTop={false}
        >
          Localizar/Validar
        </UButton>
      </form>
    </Container>
  );
}

export default Form;
